import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Divider } from 'shared/ui/Divider/Divider'
import { CardFilter, type ICardFilter, type ICardFilterProps } from './CardFilter/CardFilter'
import styles from './styles.module.scss'

type ICardsFilterProps<T = string> = {
  items: ICardFilter<T>[]
  wrapperClassName?: string
  underline?: boolean
  type?: 'detailed' | 'simple'
} & ICardFilterProps<T>

export const CardsFilter = observer(
  <T,>({ items, wrapperClassName, underline, ...props }: ICardsFilterProps<T>) => {
    return (
      <>
        <div className={classNames(styles.wrap, wrapperClassName)}>
          {items.map((item) => (
            <CardFilter key={item.key as string} item={item} {...props} />
          ))}
        </div>
        {underline && <Divider sx={{ marginTop: '14px' }} />}
      </>
    )
  }
)
